import { createPushLoggly, setLoggly as setLoggly_ } from "@mozioinc/logging";
import { getEnvs } from "./env";
import { getWhiteLabel } from "./white-label";

const { VERCEL_GIT_COMMIT_SHA, VERCEL_ENV, MOZIO_PUBLIC_LOGGLY_TOKEN } =
  getEnvs();

export let pushLoggly: ReturnType<typeof createPushLoggly>;

export const setLoggly = () => {
  setLoggly_({
    env: VERCEL_ENV,
    token: MOZIO_PUBLIC_LOGGLY_TOKEN,
  });

  const { partnerRef } = getWhiteLabel();
  pushLoggly = createPushLoggly({
    appName: "esim",
    appVersion: window.APP_VERSION || VERCEL_GIT_COMMIT_SHA,
    env: VERCEL_ENV,
    partnerRef,
  });
};
